<template>
  <h2 class="text-xl font-bold text-blue">Success! Your email was sent to:</h2>
  <HorizontalSeparator class="mb-4" />
  <h1 class="mb-4 text-lg font-bold text-blue">{{ agency.Name }}</h1>
  <p class="mb-4">
    Thank you for using Agency Central's recruitment directory.
  </p>
  <InputButton style-type="contact-form" @click="$emit('closeClick')" block>
    Close this window<br />
    <span class="hidden sm:inline-block">
      and return to the listing of agencies
    </span>
  </InputButton>
</template>

<script>
import HorizontalSeparator from 'Components/HorizontalSeparator';
import InputButton from 'Components/InputButton';

export default {
  name: 'ContactEmailSuccess',
  components: { InputButton, HorizontalSeparator },
  props: {
    agency: {
      type: Object,
    },
  },
};
</script>
